module.exports = __webpack_public_path__ + "static/img/h1-1.5961843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h1-1.png
// module id = CblC
// module chunks = 1